import type { Store } from "@/stores";
import { useMapStoreStateToClientState } from "@/hooks/useMapStoreStateToClientState";
import { useQuery } from "@/hooks/useQuery";

function useStateOfFareFamilies(store: Store, isPaxPage = false) {
  const { isDomestic, isRoundTrip, isOneWay } = useQuery();
  return useMapStoreStateToClientState(
    store,
    (store: Store) => {
      const pageStore = isRoundTrip
        ? store.appStore.stepByStepSearchPage.currentStepStore
        : store.appStore.completeSearchPage;
      const paxPageStore = store.appStore.flightsPaxPage;

      const fareFamilyStore = isPaxPage
        ? paxPageStore.fareFamilies
        : pageStore.searchResults.fareFamilies;
      return {
        isDomestic,
        isRoundTrip,
        isOneWay,
        currentStep: store.appStore.stepByStepSearchPage.currentStep,
        $fareFamilies: fareFamilyStore.$fareFamilies,
        $richContent: store.appStore.flightInfo.$richContent,
        $fare: store.appStore.flightInfo.$fare,
        selectedItineraryFareFamilies: pageStore.selectedItineraryFareFamilies,
        selectedFareFamilyItinerary: pageStore.selectedFareFamilyItinerary,
        displayItinerary: pageStore.displayItinerary,
        selectedItinerary: pageStore.selectedItinerary,
        fareFamiliesStore: fareFamilyStore,
        selectFareFamilyItinerary: pageStore.selectFareFamilyItinerary,
        deselectFareFamilyItinerary: pageStore.deselectFareFamilyItinerary,
        selectItinerary: pageStore.selectItinerary,
        setDisplayItinerary: pageStore.setDisplayItinerary,
        getItinerary: isPaxPage
          ? fareFamilyStore.fareFamilyItinerary
          : pageStore.searchResults.getItinerary,
        $resources: store.appStore.flightInfo.$resources,
        setIsFareFamilyUpgraded: store.uiStore.setIsFareFamilyUpgraded,
        flightInfoStore: store.appStore.flightInfo,
        isLoadingFareRules: store.appStore.flightInfo.fareRules.isLoading,
      };
    },
    [isRoundTrip],
  );
}

export default useStateOfFareFamilies;
